import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterHomePageHome = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("home/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.PageHome />,
        });
      })
      .catch(reject);
  });
});

export const LazyHomePageHome = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterHomePageHome />
    </Suspense>
  );
};
